import { JSX } from "react";
import { Attestation } from "./models/attestation";
import { formatUnconvertedDateCustom } from "@app/shared";

interface QdpAttestorDetailsPanelProps {
  attestation: Attestation;
}

function dashed(value: string) {
  return value || "--";
}

export default function QdpAttestorDetailsPanel(props: QdpAttestorDetailsPanelProps): JSX.Element {
  return (
    <>
      <div className="card">
        <ul className="list-group list-group-flush">
          <li className="list-group-item bordered evidence-header">
            <div className="col-6 text-right"><b>Item</b></div>
            <div className="col-6"><b>Value</b></div>
          </li>
          <li className="list-group-item bordered">
            <div className="col-6 text-right"><b>Outreach Method</b></div>
            <div className="col-6"><b>{dashed(props.attestation.OutreachMethod)}</b></div>
          </li>
          <li className="list-group-item bordered">
            <div className="col-6 text-right"><b>Attestation Method</b></div>
            <div className="col-6"><b>{dashed(props.attestation.ValidationMethod)}</b></div>
          </li>
          <li className="list-group-item bordered">
            <div className="col-6 text-right"><b>Roster Name</b></div>
            <div className="col-6"><b>{dashed(props.attestation.RosterName)}</b></div>
          </li>
          <li className="list-group-item bordered">
            <div className="col-6 text-right"><b>Publisher</b></div>
            <div className="col-6"><b>{dashed(props.attestation.Publisher)}</b></div>
          </li>
          <li className="list-group-item bordered">
            <div className="col-6 text-right"><b>Attester Full Name</b></div>
            <div className="col-6"><b>{dashed(props.attestation.AttestorName)}</b></div>
          </li>
          <li className="list-group-item bordered">
            <div className="col-6 text-right"><b>Attester Email</b></div>
            <div className="col-6"><b>{dashed(props.attestation.EmailAddress)}</b></div>
          </li>
          <li className="list-group-item bordered">
            <div className="col-6 text-right"><b>Attester Phone</b></div>
            <div className="col-6"><b>{dashed(props.attestation.PhoneNumber)}</b></div>
          </li>
          <li className="list-group-item bordered">
            <div className="col-6 text-right"><b>Date of Attestation</b></div>
            <div className="col-6"><b>{dashed(formatUnconvertedDateCustom(props.attestation.AttestationDate, "L"))}</b></div>
          </li>
        </ul>
      </div>
    </>
  );
}